import { forwardRef } from 'react';
import type { SVGProps, Ref } from 'react';
type Props = SVGProps<SVGSVGElement>;
/**
 * @public
 */
const SvgVk = forwardRef((props: Props, svgRef: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1.5em"
    height="1.5em"
    fill="none"
    viewBox="0 0 24 24"
    ref={svgRef}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.808 18.14h1.303s.393-.044.593-.258c.19-.2.19-.572.19-.572s-.028-1.747.788-2.003c.804-.255 1.824 1.686 2.912 2.432.83.57 1.455.448 1.455.448l2.911-.04s1.525-.095.804-1.293c-.055-.095-.409-.884-2.15-2.502-1.824-1.687-1.579-1.415.613-4.34 1.332-1.782 1.877-2.87 1.7-3.333-.15-.435-1.142-.327-1.142-.327l-3.266.028s-.244-.028-.421.081c-.177.108-.285.355-.285.355s-.519 1.386-1.211 2.557c-1.472 2.474-2.057 2.61-2.288 2.447-.547-.355-.407-1.433-.407-2.205 0-2.395.366-3.4-.708-3.659-.354-.082-.617-.136-1.528-.15-1.17-.013-2.156.009-2.715.282-.367.184-.653.59-.489.612.218.027.706.132.965.487.34.458.325 1.483.325 1.483s.192 2.825-.448 3.176c-.448.238-1.047-.254-2.352-2.499-.667-1.142-1.17-2.42-1.17-2.42s-.096-.233-.272-.369c-.206-.15-.505-.204-.505-.204l-3.114.027s-.463.015-.625.218c-.15.177-.015.558-.015.558s2.436 5.7 5.197 8.57c2.53 2.631 5.4 2.462 5.4 2.462l-.045-.05z"
      clipRule="evenodd"
    />
  </svg>
));
SvgVk.defaultProps = {
  'aria-hidden': true,
  focusable: 'false',
  role: 'img',
};
export default SvgVk;
